<template>
  <div class="col-12 bg-white-primary mx-auto">
    <div
      class="d-flex flex-column flex-md-row justify-content-md-start align-items-center border-bottom mb-1 mx-0 ps-0 ps-md-3 pe-0"
    >
      <div class="size-16 fw-bold text-center pt-4 pb-2 pb-md-4 ps-0 ps-md-2">経験業種・年数</div>
    </div>
    <div class="row mx-3 py-4 gap-3">
      <div
        v-if="optionalInformationStore.candidate_resume_industries.length > 0"
        class="d-flex gap-1 gap-md-3"
      >
        <div class="col-8 col-md-4 pe-0">
          <label class="form-label size-12 d-block" for="">経験業種</label>
        </div>
        <div class="col-3 col-md-2">
          <label class="form-label size-12 d-block" for="">年数</label>
        </div>
        <div class="w-29x"></div>
      </div>
      <div
        v-for="(resume_industry, index) in optionalInformationStore.candidate_resume_industries"
        :key="index"
        class="d-flex w-100 gap-1 gap-md-3 pb-3"
      >
        <Field
          v-slot="{ field, errors }"
          v-model="resume_industry.industry_id"
          :name="`industry_id${index}`"
        >
          <div class="col-md-4 col-8 pe-0">
            <select
              class="form-select select-input-primary size-14 p-0d8 pe-4"
              v-bind="field"
              @change="onChangeIndustryId($event, resume_industry, index)"
            >
              <option :value="0" disabled selected>選択してください</option>
              <optgroup
                v-for="industry in filteredIndustries(index)"
                :key="industry.id"
                :label="industry.name"
              >
                <option v-for="item in industry.children" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </optgroup>
            </select>
            <div v-if="errors[0]" class="d-block invalid-feedback">{{ errors[0] }}</div>
          </div>
        </Field>
        <Field v-slot="{ errors }" :name="`years_of_experience${index}`">
          <div class="col-3 col-md-2 pe-0">
            <select
              v-model="resume_industry.years_of_experience"
              class="form-select select-input-primary size-14 p-0d8"
              :class="{ 'is-invalid': !!errors.length }"
              @change="onChangeYear($event, resume_industry, index)"
            >
              <option
                v-for="year in yearDefault"
                :key="year.value"
                :value="year.value"
                :selected="resume_industry.years_of_experience === year.value"
              >
                {{ year.name }}
              </option>
            </select>
            <div v-if="errors[0]" class="d-block invalid-feedback">{{ errors[0] }}</div>
          </div>
        </Field>
        <div class="d-flex justify-content-center align-items-center flex-column ms-2">
          <img
            alt="Remove icon"
            class="h-29x w-29x cursor-pointer"
            src="@/assets/images/icons/remove-icon.svg"
            @click="() => onRemoveIndustry(index)"
          />
        </div>
      </div>
      <div class="row justify-content-center w-100 m-0">
        <button
          type="button"
          class="btn btn-outline-secondary py-0d75 d-flex justify-content-center align-items-center size-12 w-12 rounded-5 h-36x"
          @click="addItemForIndustry"
        >
          <div class="icon w-1"></div>
          <span class="ms-2">経験業種を追加する</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useOptionalInformationStore } from '@/stores/resume-candidate/OptionalInformation.store';
import { getIndustries } from '@/apis/candidate';
import { IndustryType } from '@/types/models/industryType';
import { yearDefault } from '@/constant';
import { Field, useFieldArray } from 'vee-validate';

const industries = ref<IndustryType[]>([]);
const optionalInformationStore = useOptionalInformationStore();
const { update, remove } = useFieldArray('candidate_resume_industries');

onMounted(() => {
  loadIndustries();
});

const filteredIndustries = (index: number): IndustryType[] => {
  return industries.value.map((industry) => {
    const clonedIndustry = { ...industry };
    clonedIndustry.children = clonedIndustry.children?.filter((child) => {
      return !optionalInformationStore.candidate_resume_industries.some(
        (industries, i) => industries.industry_id === child.id && i !== index
      );
    });
    return clonedIndustry;
  });
};

const loadIndustries = async (): Promise<void> => {
  const response = await getIndustries();
  if (response.status === 200) industries.value = response.data;
};

const addItemForIndustry = (): void => {
  optionalInformationStore.candidate_resume_industries.push({
    industry_id: 0,
    years_of_experience: 0,
    index: new Date().getTime(),
  });
};

const onChangeIndustryId = ($event: any, resume_industry: any, index: number): void => {
  update(index, { ...resume_industry, occupation_id: $event.target.value });
  optionalInformationStore.candidate_resume_industries[index].industry_id = +$event.target.value;
};

const onChangeYear = ($event: any, resume_industry: any, index: number): void => {
  update(index, { ...resume_industry, years_of_experience: $event.target.value });
  optionalInformationStore.candidate_resume_industries[index].years_of_experience =
    +$event.target.value;
};

const onRemoveIndustry = (index: number): void => {
  remove(index);
  optionalInformationStore.candidate_resume_industries.splice(index, 1);
};
</script>
